<mat-toolbar color="primary" class="app-header">
  <pp-navigate-back />
  @if (!layoutService.isSmallDevice()) {
    <a [routerLink]="['/home']">
      <img
        ngSrc="../../../assets/processpuzzle-logo-with-title.jpg"
        class="app-logo"
        priority
        width="75"
        height="85"
        (click)="onLogoClick()"
        (keydown)="onLogoKeyPress($event)"
        alt="ProcessPuzzle Logo" />
    </a>
    <button mat-icon-button (click)="sidenavToggle()" aria-label="Toggle the navigation sidebar">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <!-- Renders on a handset only, where the sidenav renders nothing, from the APPLICATION_CONTEXT's routes. -->
  <pp-nav-menu />
  <!-- Grows to fill the row, so the controls after it line up at the far end. -->
  <pp-app-title />
  <pp-language-selector />
  <pp-auth-button />
</mat-toolbar>
